import { isAssignorComplete } from '@/utils/mixins/flux-control'

const PayerExtract = () => import('./pages/extract')
const AdminExtract = () => import('./pages/extract-admin')

export default [
  {
    path: '/extract',
    name: 'dashboard.extract',
    component: PayerExtract,
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      isAssignorComplete(next)
    }
  },
  {
    path: '/admin_extract',
    name: 'dashboard.admin_extract',
    component: AdminExtract,
    meta: { requiresAuth: true },
    beforeEnter: (to, from, next) => {
      isAssignorComplete(next)
    }
  }
]



// WEBPACK FOOTER //
// ./src/features/extract/routes.js